// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1TEWy","question":"Question_question__2TfLu","description":"Question_description__oaJwg"};